import App from 'features/app/components/App';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';
import 'styles/font.css';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  const routerBasename =
    import.meta.env.BASE_URL && import.meta.env.BASE_URL !== '/'
      ? import.meta.env.BASE_URL.replace(/\/$/, '')
      : undefined;

  root.render(
    <StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <Router basename={routerBasename} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
          </Router>
        </PersistGate>
      </Provider>
    </StrictMode>
  );
}
